import { Box, Text, Link } from "@chakra-ui/react";

const Footer = () => {
  return (
    <footer>
      <Box paddingY={8}>
        <Text textAlign="center">
          Une question? Contactez{" "}
          <Link href="mailto:info@biologie-elearning.fr">
            info@biologie-elearning.fr
          </Link>
        </Text>
      </Box>
    </footer>
  );
};

export default Footer;
